export const FormElementsBehaviour = {
  methods: {
    ValidateInput(event) {
      let el = event.target.closest('label').querySelector('span');
      this.Clean(event.target);
      if (el !== null) {
        let input = event.target;
        if (input.value === undefined) {
          input = event.target.parentNode.previousSibling;
        }
        if (input.value.length > 0) {
          if (!Object.values(el.classList).includes('show')) {
            el.classList.add('show');
            el.closest('label').classList.add('filled');
          }
        } else {
          el.classList.remove('show');
          el.closest('label').classList.remove('filled');
        }
      }
    },
    Clean(item) {
      let el = item.closest('label').querySelector('.bpa-error');
      if (el) {
        el.remove();
      }
    },
    Error(item, message) {
      if (item.closest('label').querySelector('.bpa-error')) {
        return;
      }
      item.closest('label').insertAdjacentHTML('beforeend', "<p class='bpa-error'>"+ message +"</p>");
    }
  }
};
